<div class="h-100">
  <div class="app-loading">
    <div class="logo"></div>
  </div>
</div>
